module.exports = __webpack_public_path__ + "img/hamburgenergie-logo@2x.05feb284.png";